import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ChangeVisibility from './components/ChangeVisibility';

const container = document.getElementById('root');
const root = createRoot(container);


root.render(
  <React.StrictMode>
    <div>
      {/* <ChangeVisibility /> */}
      <App />
    </div>
  </React.StrictMode>
);

reportWebVitals();